import React from "react";
import { useField } from "formik";

function ChipSelect({
  label = "Chips",
  name,
  options = [],
  required = false,
  onChange,
}) {
  const [field, meta, helpers] = useField(name);
  const { setValue } = helpers;

  const handleSelect = (item) => {
    const value = {
      label: item.name,
      value: item.id,
    };

    setValue(value);
    typeof onChange === "function" && onChange(value);
  };

  return (
    <div style={{ marginBottom: "16px", width: "100%" }}>
      {/* Label */}
      <label
        className="mb-2 fw-semibold"
        style={{ fontSize: "12px", color: "#0F2A44" }}
      >
        {label}
        {required && <span> *</span>}
      </label>

      {/* Buttons */}
      <div className="d-flex gap-2 flex-wrap">
        {options.map((item) => {
          const isActive = field.value?.value === item.id;

          return (
            <button
              key={item.id}
              type="button"
              className={`btn px-3 py-1 ${
                isActive ? "bg-primary text-white" : "border text-black"
              }`}
              style={{ fontSize: "12px", borderRadius: "8px" }}
              onClick={() => handleSelect(item)}
            >
              {item.name}
            </button>
          );
        })}
      </div>

      {/* Error */}
      {meta.touched && meta.error && (
        <div className="error">
          {typeof meta.error === "string" ? meta.error : meta.error?.value}
        </div>
      )}
    </div>
  );
}

export default ChipSelect;
